/* Définitions d'état de la fiche : survol, clavier et toucher. L'état de la
   pièce reste fixe ; chaque instance se reconnecte aussi dans l'éditeur. */
(function () {
  'use strict';
  if (customElements.get('product-condition-scale')) return;

  class ProductConditionScale extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.choices = Array.from(this.querySelectorAll('[data-condition]'));
      this.descriptions = Array.from(this.querySelectorAll('[data-condition-description]'));
      if (!this.choices.length) return;
      this.bound = true;
      this.current = this.dataset.current;
      const choiceFrom = target => target instanceof Element && target.closest('[data-condition]');
      this.onHover = event => {
        const choice = choiceFrom(event.target);
        if (event.pointerType !== 'touch' && choice && this.contains(choice)) this.show(choice.dataset.condition);
      };
      this.onLeave = event => {
        if (event.pointerType === 'touch') return;
        const focused = choiceFrom(document.activeElement);
        this.show(focused && this.contains(focused) ? focused.dataset.condition : this.current);
      };
      this.onFocus = event => {
        const choice = choiceFrom(event.target);
        if (choice && this.contains(choice)) this.show(choice.dataset.condition);
      };
      this.onBlur = event => {
        if (!this.contains(event.relatedTarget)) this.show(this.current);
      };
      this.onKey = event => {
        if (event.key !== 'Escape') return;
        this.show(this.current);
        this.choices.find(choice => choice.dataset.condition === this.current)?.focus();
      };
      this.addEventListener('pointerover', this.onHover);
      this.addEventListener('pointerleave', this.onLeave);
      this.addEventListener('focusin', this.onFocus);
      this.addEventListener('focusout', this.onBlur);
      this.addEventListener('click', this.onFocus);
      this.addEventListener('keydown', this.onKey);
      this.show(this.current);
    }

    show(index) {
      this.choices.forEach(choice => choice.classList.toggle('is-preview', choice.dataset.condition === index && index !== this.current));
      this.descriptions.forEach(description => {
        const visible = description.dataset.conditionDescription === index;
        description.classList.toggle('is-visible', visible);
        description.setAttribute('aria-hidden', String(!visible));
      });
    }

    disconnectedCallback() {
      if (!this.bound) return;
      this.removeEventListener('pointerover', this.onHover);
      this.removeEventListener('pointerleave', this.onLeave);
      this.removeEventListener('focusin', this.onFocus);
      this.removeEventListener('focusout', this.onBlur);
      this.removeEventListener('click', this.onFocus);
      this.removeEventListener('keydown', this.onKey);
      this.bound = false;
    }
  }
  customElements.define('product-condition-scale', ProductConditionScale);
})();
